




import { MutationTypes } from '@/store/mutation-types'
import { Component, Vue, Watch } from 'vue-property-decorator'
import websocketService from '@/services/websocket-service'

@Component
export default class App extends Vue {
  created() {
    // Set vm in store for access it from all places
    this.$store.commit(MutationTypes.SET_VM, this)

    // Initialize WebSocket if user is already authenticated
    this.initializeWebSocketIfAuthenticated()
  }

  beforeDestroy() {
    // Disconnect WebSocket when app is destroyed
    websocketService.disconnect()
  }

  @Watch('$store.state.token', { deep: true })
  onTokenChanged() {
    // Reinitialize WebSocket when token changes (login/logout)
    this.initializeWebSocketIfAuthenticated()
  }

  private initializeWebSocketIfAuthenticated() {
    if (this.$store.getters.isUserAuthenticated) {
      const token = this.$store.state.token?.accessToken

      if (token) {
        // Get Account Updates WebSocket URL from environment variable
        const wsUrl = process.env.VUE_APP_ACCOUNT_UPDATES_WS_URL

        if (!wsUrl) {
          console.error('❌ VUE_APP_ACCOUNT_UPDATES_WS_URL not configured in environment variables')
          return
        }

        console.log('🔌 Initializing Account Updates WebSocket connection to:', wsUrl)
        websocketService.connect(wsUrl, token)
      }
    } else {
      // User is not authenticated, disconnect WebSocket
      websocketService.disconnect()
    }
  }
}
